import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Image as ImageIcon, Trash2, ShoppingCart } from 'lucide-react';
import { useShopCart } from '../../context/ShopCartContext';

const formatRWF = (n) => new Intl.NumberFormat('en-RW', { maximumFractionDigits: 0 }).format(n);

export default function ShopCart() {
  const { items, setQuantity, removeItem, subtotal } = useShopCart();

  if (items.length === 0) {
    return (
      <div className="max-w-3xl mx-auto px-4 py-16 text-center" data-testid="cart-empty">
        <ShoppingCart className="w-16 h-16 mx-auto text-muted-foreground mb-4" />
        <h2 className="text-2xl font-serif font-bold mb-2">Your cart is empty</h2>
        <p className="text-muted-foreground mb-6">Browse our products and add your favourites.</p>
        <Link to="/shop/products"><Button data-testid="cart-empty-shop-now">Shop Now</Button></Link>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-serif font-bold mb-6">Your Cart</h1>
      <div className="grid md:grid-cols-3 gap-6">
        <div className="md:col-span-2 space-y-3" data-testid="cart-items">
          {items.map(item => (
            <div key={item.product_id} className="flex items-center gap-4 p-4 bg-card rounded-xl border border-border" data-testid={`cart-item-${item.product_id}`}>
              <div className="w-16 h-16 rounded-lg bg-muted flex items-center justify-center flex-shrink-0">
                {item.image_url ? <img src={item.image_url} alt={item.name} className="w-full h-full object-cover rounded-lg" /> : <ImageIcon className="w-6 h-6 text-muted-foreground" />}
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-medium truncate">{item.name}</div>
                <div className="text-sm text-muted-foreground">RWF {formatRWF(item.unit_price)} / {item.unit}</div>
              </div>
              <Input type="number" min="1" value={item.quantity} onChange={(e) => setQuantity(item.product_id, parseFloat(e.target.value) || 1)} className="w-20" data-testid={`cart-qty-${item.product_id}`} />
              <div className="w-24 text-right font-semibold">RWF {formatRWF(item.unit_price * item.quantity)}</div>
              <Button variant="ghost" size="sm" onClick={() => removeItem(item.product_id)} data-testid={`cart-remove-${item.product_id}`}><Trash2 className="w-4 h-4 text-red-500" /></Button>
            </div>
          ))}
        </div>
        <div className="md:col-span-1">
          <div className="p-5 bg-card rounded-xl border border-border sticky top-24">
            <div className="font-semibold mb-3">Order summary</div>
            <div className="flex justify-between text-sm mb-2"><span className="text-muted-foreground">Subtotal</span><span data-testid="cart-subtotal">RWF {formatRWF(subtotal)}</span></div>
            <div className="flex justify-between text-sm mb-3"><span className="text-muted-foreground">Delivery</span><span className="text-muted-foreground text-xs">calculated at checkout</span></div>
            <Link to="/shop/checkout"><Button className="w-full" data-testid="cart-checkout-btn">Proceed to Checkout</Button></Link>
          </div>
        </div>
      </div>
    </div>
  );
}
